import { z } from 'zod';

import { CreateDealSchema, UpdateDealStageSchema } from './deal.schema';

/**
 * SPA deal form uses `title` (maps to API `dealName` on submit).
 * Keeps constraints aligned with CreateDealSchema / stage enum.
 */
export const DealFormSchema = z
  .object({
    title: CreateDealSchema.shape.dealName,
    brandId: CreateDealSchema.shape.brandId,
    stage: UpdateDealStageSchema.shape.stage,
    dealValue: CreateDealSchema.shape.dealValue,
    startDate: z.string().optional(),
    endDate: z.string().optional(),
    description: CreateDealSchema.shape.description,
  })
  .refine(
    (data) => {
      if (data.startDate && data.endDate) {
        return new Date(data.startDate) <= new Date(data.endDate);
      }
      return true;
    },
    { message: 'Start date must be before or equal to end date', path: ['endDate'] }
  );

export type DealFormData = z.infer<typeof DealFormSchema>;
